import { render, staticRenderFns } from "./cardapio.vue?vue&type=template&id=6ec9a926&scoped=true"
import script from "./cardapio.vue?vue&type=script&lang=js"
export * from "./cardapio.vue?vue&type=script&lang=js"
import style0 from "./cardapio.vue?vue&type=style&index=0&id=6ec9a926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec9a926",
  null
  
)

export default component.exports